import React from "react"
import { Grid } from "@material-ui/core"

import { Portlet } from "@/components"
import { ChatBotCategory } from "@/protocols/chatBot"
import { WebhookTemplateType } from "@/protocols/webhook"

import { ShortChatBotFlow } from "@/services/ChatBotFlow"

import FlowListItemButtons from "@/pages/Admin/Flow/FlowList/FlowListItem/FlowListItemButtons"
import FlowListItemDetails from "@/pages/Admin/Flow/FlowList/FlowListItem/FlowListItemDetails"
import FlowListItemtrigger from "@/pages/Admin/Flow/FlowList/FlowListItem/FlowListItemTrigger"

type FlowListItemProps = {
	chatBotFlow: Pick<ShortChatBotFlow, "id" | "name" | "active" | "updated_at" | "consolidated_data" | "tag" | "board">
	chatBotCategory: ChatBotCategory | undefined
	flowEditorPath: string
	webhookTemplateType?: WebhookTemplateType | "custom" | undefined
	onExport: () => Promise<void> | void
	onEdit: () => void
}

const FlowListItem: React.FC<FlowListItemProps> = (props) => {
	const {
		chatBotFlow,
		chatBotCategory,
		flowEditorPath,
		webhookTemplateType,
		onExport,
		onEdit
	} = props

	return (
		<Portlet elevation={1}>
			<Grid container alignItems="center" spacing={2}>
				<Grid item md={5} lg={4}>
					<FlowListItemtrigger
						flowEditorPath={flowEditorPath}
						webhookTemplateType={webhookTemplateType}
						chatBotCategory={chatBotCategory}
						chatBotFlow={chatBotFlow}
					/>
				</Grid>

				<Grid item md={5} lg={6}>
					<FlowListItemDetails chatBotFlow={chatBotFlow} />
				</Grid>

				<Grid item md={2}>
					<FlowListItemButtons
						flowEditorPath={flowEditorPath}
						onEdit={onEdit}
						onExport={onExport}
						chatBotFlow={{
							id: chatBotFlow.id,
							name: chatBotFlow.name
						}}
					/>
				</Grid>
			</Grid>
		</Portlet>
	)
}

export default FlowListItem
